import React from 'react';

import Register from '../components/Register';
import Layout from '../components/Layout';
const register = () => {

    return (
        <Layout>
            <Register />
        </Layout>    
    )
}

export default register;
